"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RoomosHeaderDefault = exports.RoomosAuthType = exports.NOT_SET = void 0;
var _uuid = require("uuid");
var NOT_SET = exports.NOT_SET = "NOT_SET";
var RoomosAuthType = exports.RoomosAuthType = /*#__PURE__*/function (RoomosAuthType) {
  RoomosAuthType["BASIC"] = "basic";
  RoomosAuthType["NONE"] = "none";
  return RoomosAuthType;
}({});
var RoomosHeaderDefault = exports.RoomosHeaderDefault = function RoomosHeaderDefault() {
  return {
    id: (0, _uuid.v4)(),
    name: "",
    description: "",
    authData: {
      type: RoomosAuthType.BASIC,
      username: "",
      password: ""
    },
    address: {
      value: ""
    },
    status: "Connecting"
  };
};